import { cva, type VariantProps } from 'class-variance-authority';
import { createElement, forwardRef } from 'react';
import { cn } from './utils';

const agTextVariants = cva('', {
  variants: {
    size: {
      display: 'text-display',
      h1: 'text-h1',
      h2: 'text-h2',
      h3: 'text-h3',
      h4: 'text-h4',
      h5: 'text-h5',
      h6: 'text-h6',
      '20': 'text-20',
      '18': 'text-18',
      '16': 'text-16',
      '14': 'text-14',
      '13': 'text-13',
      '12': 'text-12',
    },
    weight: {
      light: 'font-light',
      regular: 'font-regular',
      medium: 'font-medium',
      semibold: 'font-semibold',
      bold: 'font-bold',
      extrabold: 'font-extrabold',
      black: 'font-black',
    },
    color: {
      primary: 'text-neutral-13',
      secondary: 'text-neutral-alpha-9',
      brand: 'text-brand-6',
      white: 'text-white',
      black: 'text-black',
      inherit: 'text-inherit',
    },
  },
});

type AgTextProps = VariantProps<typeof agTextVariants> & React.HTMLAttributes<HTMLElement>;

export const AgText = forwardRef<HTMLElement, AgTextProps>(
  ({ className, size = '16', weight = 'regular', color = 'primary', children, ...props }, ref) => {
    // Auto-select semantic element based on size
    const element = getSemanticElement(size);

    return createElement(
      element,
      { className: cn(agTextVariants({ size, weight, color, className })), ref, ...props },
      children
    );
  }
);

AgText.displayName = 'AgText';

function getSemanticElement(size: AgTextProps['size']) {
  switch (size) {
    case 'display':
    case 'h1':
      return 'h1';
    case 'h2':
      return 'h2';
    case 'h3':
      return 'h3';
    case 'h4':
      return 'h4';
    case 'h5':
      return 'h5';
    case 'h6':
      return 'h6';
    default:
      return 'p';
  }
}
